var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85759 16.4998H1.74777V6.48531H4.85759V16.4998ZM3.301 5.11924C2.30658 5.11924 1.5 4.29558 1.5 3.30116C1.5 2.8235 1.68975 2.36541 2.0275 2.02765C2.36526 1.6899 2.82335 1.50015 3.301 1.50015C3.77866 1.50015 4.23675 1.6899 4.57451 2.02765C4.91226 2.36541 5.10201 2.8235 5.10201 3.30116C5.10201 4.29558 4.29509 5.11924 3.301 5.11924ZM16.4967 16.4998H13.3935V11.6248C13.3935 10.463 13.3701 8.97303 11.7767 8.97303C10.1598 8.97303 9.91205 10.2353 9.91205 11.5411V16.4998H6.80558V6.48531H9.78817V7.85138H9.8317C10.2469 7.06455 11.261 6.23419 12.7741 6.23419C15.9214 6.23419 16.5 8.30674 16.5 10.9987V16.4998H16.4967Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.773ed324ddf7d05986e9f011fd360f4b.svg";
export { ForwardRef as ReactComponent };